import { useEffect } from 'react';
import { H2 } from '@comeon/ui';

import { Translations } from '~/components/payment/quick-deposit-beta/components-v2/types';
import { TAction, TriggerViewFn } from '~/components/payment/quick-deposit-beta/types';
import {
	LIMITS_REDIRECT_CONFIRM,
	textKeysQDAmountScreen
} from '~/components/payment/quick-deposit-beta/utils/constants';
import usePaymentTracking from '~/components/payment-beta/deposit/hooks/use-payment-tracking';
import { getLimitType } from '~/components/payment/quick-deposit-beta/utils/qd-helpers';

// Styled components
import { CloseButton, HeadWrapper, RoundedButtonSecondary, SubTitle } from './styles';
import { ContentWrapper } from '~/components/payment/quick-deposit-beta/components-v2/deposit-amount/styles';

type Props = {
	addView: (...args: string[]) => TAction;
	formattedLimit: string;
	handleClose: () => void;
	isLugasLimit: boolean;
	responsibleGamingLimitType?: number;
	translation: Translations<typeof textKeysQDAmountScreen>;
	updateViews: (...args: ReturnType<TriggerViewFn>[]) => TAction;
};

const NewQDRGScreen = ({
	formattedLimit,
	addView,
	handleClose,
	translation: t,
	updateViews,
	isLugasLimit,
	responsibleGamingLimitType
}: Props) => {
	const { trackQDEvent } = usePaymentTracking();

	// Track RG limits popup appearance on component mount
	useEffect(() => {
		const limitType = getLimitType(responsibleGamingLimitType) as string;
		trackQDEvent({
			pixel_deposit_action: `${limitType}-limits-reached-popup-appeared`
		});
	}, [trackQDEvent, responsibleGamingLimitType]);

	const handleUpdateLimitsClick = () => {
		// Track update limits button click
		const limitType = getLimitType(responsibleGamingLimitType) as string;
		trackQDEvent({
			pixel_deposit_action: `click-update-${limitType}-limits`
		});

		updateViews(addView(LIMITS_REDIRECT_CONFIRM));
	};
	return (
		<>
			<HeadWrapper>
				<H2 data-at="main-title-deposit-limit">
					{isLugasLimit ? t.LUGAS_LIMIT_REACHED_TITLE : t.DEPOSIT_LIMITS_TEMPLATE_TITLE}
				</H2>
				<CloseButton className="at-icon-close page-head__close" onClick={handleClose} type="button" />
			</HeadWrapper>
			<ContentWrapper>
				<SubTitle dataAt="sub-title-deposit-limit">
					{isLugasLimit ? t.LUGAS_LIMIT_REACHED_MESSAGE : `${t.SELIMIT_REACHED_MESSAGE} ${formattedLimit}`}
				</SubTitle>
				<RoundedButtonSecondary
					smallfont
					onClick={handleUpdateLimitsClick}
					type="submit"
					className="u-relative button u-mb1"
					title="title"
					dataAt="new-mobile-quick-deposit-update-limits"
				>
					{t.UPDATE_DEPOSIT_LIMIT}
				</RoundedButtonSecondary>
			</ContentWrapper>
		</>
	);
};

export default NewQDRGScreen;
